// src/pages/TrustSafety.jsx
import React from "react";
import "./LegalPages.css";

const TrustSafety = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Trust &amp; Safety</h1>
        <p>
          NexterZone is designed to protect buyers and sellers and to reduce theft, fraud, and unsafe exchanges.
          Safety is built into the process — not left to chance.
        </p>
      </div>

      <div className="legal-grid">
        <section className="legal-card">
          <h2>No direct meetups</h2>
          <p>
            NexterZone is not a “meet-in-a-parking-lot” marketplace. We manage the trade steps so users are not forced
            into risky situations.
          </p>
        </section>

        <section className="legal-card">
          <h2>No contact sharing</h2>
          <p>
            Users do not exchange phone numbers, emails, or addresses inside the trade flow. This reduces scams,
            pressure tactics, and off-platform deals.
          </p>
        </section>

        <section className="legal-card">
          <h2>Platform-managed workflow</h2>
          <ul>
            <li>Offer accepted</li>
            <li>Verification checks (risk and compliance)</li>
            <li>Pickup scheduling</li>
            <li>Condition checks / inspection</li>
            <li>Delivery scheduling</li>
            <li>Completion</li>
          </ul>
        </section>

        <section className="legal-card">
          <h2>Risk screening</h2>
          <p>
            Certain items or patterns may be flagged for review. Trades can be paused, cancelled, or escalated to
            protect the community.
          </p>
        </section>

        <section className="legal-card">
          <h2>Verification evidence</h2>
          <p>
            Sellers may be required to provide photos, videos, and condition confirmations before pickup. This helps
            deter stolen goods and prevents misrepresentation.
          </p>
        </section>

        <section className="legal-card">
          <h2>Privacy by default</h2>
          <p>
            Personal details are not displayed publicly. Sensitive information is handled securely and only accessed
            by authorized NexterZone staff when required for logistics or safety.
          </p>
        </section>
      </div>

      <section className="legal-callout">
        <h3>Our commitment</h3>
        <p>
          These measures exist to reduce theft and fraud, protect honest users, and build a trusted trading
          environment — even if it means trading is a bit more structured.
        </p>
      </section>
    </div>
  );
};

export default TrustSafety;
